<template>
    <div class="">
        <div class="form-group">
              <label>Aggiungi filtro:</label>
              <select class="form-control" @change="addFilter($event)">
                  <option value="">---</option>
                  <option v-for="filter in selection_filters" :value="filter.key" >
                      {{filter.value}}
                  </option>
              </select>
        </div>
        <label>Filtri inseriti</label> 
        <div class="row" v-for="(filter,index ) in filters_list">
            <div class="col-3">
                <a class="btn btn--danger" @click="deleteFilter(index)"> <i class="fas fa-trash"></i></a>
            </div>
            <div class="col-3">
                {{filter.value}}
            </div>
            <div class="col-6">
              <input type="hidden" :name="'advance_filters['+index+'][type]'" :value="filter.type">
              <input type="hidden" :name="'advance_filters['+index+'][key]'" :value="filter.key">
              <div v-if="filter.type == 'date'" >
					      <input  class="form-control" type="date" :name="'advance_filters['+index+'][value]'" :value="filter.searchTxt">
              </div>
              <div v-else>
                   <select class="form-control" :name="'advance_filters['+index+'][value]'" v-model="filter.searchTxt">
                       <option v-for="element in filter.available_values" :value="decoder(element)">
							          {{decoder(element)}}
						          </option>
                    </select>
              </div>
          </div>
        </div>
      </div>
  </template>

<script>
    export default {

        mounted() {
          console.log("parameters_already_set",this.parameters_already_set);
          console.log("selection_filters",this.selection_filters)

          this.setOlderFilters();

        },

        data()  {
            return {

                filters_list : []
            }
        },
        methods: {

            setOlderFilters(){
              for( let i =0 ; i< this.parameters_already_set.length ; i++){
                let row = this.parameters_already_set[i];

                this.filters_list.push({
                  key : row.key,
                  type  : row.type,
                  value : this.selection_filters[row.key].value,
                  searchTxt : this.decoder(row.value),//this.parameters_already_set[i].value,
                  available_values :  this.selection_filters[row.key].available_values
                });
              }
            },

            deleteFilter(index){
              Vue.delete(this.filters_list,index);
            },
            addFilter(event){
              this.filters_list.push({
                  key : event.target.value,
                  value : event.target.options[event.target.options.selectedIndex].text,
                  searchTxt : null,
                  available_values :  this.selection_filters[event.target.value].available_values,
                  type : this.selection_filters[event.target.value].type,
              });
            },
            decoder(str) {
              var textArea = document.createElement('textarea');
              textArea.innerHTML = str;
              var textDecoded = textArea.value;
              textArea.remove();
              return textDecoded;
            }
        },
        props: {
          parameters_already_set: {
            type: Array,
            required: false
          },
          selection_filters: {
            type: Object,
            required: true
          },
      },
    }
</script>

<style>

</style>
